// extracted by mini-css-extract-plugin
export var consent = "style-module--consent--9b91c";
export var description = "style-module--description--82cac";
export var link = "style-module--link--3fd94";